if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        
        // CRITICAL: Ensure custom dimension properties are included
        // Inputs with form attribute might not be included in FormData
        const widthInput = document.getElementById('width');
        const heightInput = document.getElementById('height');
        if (widthInput && heightInput && widthInput.name && heightInput.name) {
          const widthPropertyName = widthInput.name.replace('properties[', '').replace(']', '');
          const heightPropertyName = heightInput.name.replace('properties[', '').replace(']', '');
          
          // Only add if not already present (to avoid duplicates)
          if (!formData.has(`properties[${widthPropertyName}]`)) {
            formData.append(`properties[${widthPropertyName}]`, widthInput.value);
          }
          if (!formData.has(`properties[${heightPropertyName}]`)) {
            formData.append(`properties[${heightPropertyName}]`, heightInput.value);
          }
        }
        
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            // CRITICAL: Server-side validation - Validate variant matches custom measurements
            // This happens AFTER the item is added to cart, ensuring it can NEVER be wrong
            const customMeasurementsValidation = this.validateAndFixVariant(response, formData);
            if (customMeasurementsValidation.needsFix) {
              // Variant was wrong, fix it automatically
              // Note: We return here, so the outer finally will still run
              return customMeasurementsValidation.fixPromise
                .then((fixedResponse) => {
                  if (!this.error)
                    publish(PUB_SUB_EVENTS.cartUpdate, {
                      source: 'product-form',
                      productVariantId: formData.get('id'),
                      cartData: fixedResponse,
                    });
                  this.error = false;
                  const quickAddModal = this.closest('quick-add-modal');
                  if (quickAddModal) {
                    document.body.addEventListener(
                      'modalClosed',
                      () => {
                        setTimeout(() => {
                          this.cart.renderContents(fixedResponse);
                        });
                      },
                      { once: true }
                    );
                    quickAddModal.hide(true);
                  } else {
                    this.cart.renderContents(fixedResponse);
                  }
                })
                .catch((error) => {
                  console.error('Error fixing variant:', error);
                  // Still show the cart, but log the error
                  this.error = false;
                  if (!this.error)
                    publish(PUB_SUB_EVENTS.cartUpdate, {
                      source: 'product-form',
                      productVariantId: formData.get('id'),
                      cartData: response,
                    });
                  const quickAddModal = this.closest('quick-add-modal');
                  if (quickAddModal) {
                    document.body.addEventListener(
                      'modalClosed',
                      () => {
                        setTimeout(() => {
                          this.cart.renderContents(response);
                        });
                      },
                      { once: true }
                    );
                    quickAddModal.hide(true);
                  } else {
                    this.cart.renderContents(response);
                  }
                });
              // Note: We return the promise, so the outer finally will handle cleanup
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error('Error adding to cart:', e);
            this.error = true;
            this.handleErrorMessage('Der opstod en fejl. Prøv venligst igen.');
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: e.message || 'Unknown error',
              message: 'Der opstod en fejl',
            });
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            const spinner = this.querySelector('.loading__spinner');
            if (spinner) spinner.classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      // CRITICAL SERVER-SIDE VALIDATION: Validates variant matches custom measurements
      // This runs AFTER cart/add, ensuring the variant is ALWAYS correct
      validateAndFixVariant(cartResponse, formData) {
        const widthInput = document.getElementById('width');
        const heightInput = document.getElementById('height');
        
        // Only validate if custom dimension inputs exist
        if (!widthInput || !heightInput) {
          return { needsFix: false };
        }

        const customWidth = parseFloat(widthInput.value);
        const customHeight = parseFloat(heightInput.value);

        // Skip validation if no custom measurements provided
        if (isNaN(customWidth) || isNaN(customHeight) || customWidth <= 0 || customHeight <= 0) {
          return { needsFix: false };
        }

        // Get the added item from cart response
        if (!cartResponse.items || cartResponse.items.length === 0) {
          return { needsFix: false };
        }

        // Find the most recently added item
        // Check by matching properties to find the exact item we just added
        const addedItem = cartResponse.items.find(item => {
          // Properties can be an array of objects {name, value} or an object
          let itemWidth = null;
          let itemHeight = null;
          
          if (Array.isArray(item.properties)) {
            // Properties is an array of objects
            const widthProp = item.properties.find(p => 
              (p.name && (p.name.includes('Specialmål bredde') || p.name.includes('Special measure width'))) ||
              (typeof p === 'string' && p.includes('Specialmål bredde'))
            );
            const heightProp = item.properties.find(p => 
              (p.name && (p.name.includes('Specialmål højde') || p.name.includes('Special measure height'))) ||
              (typeof p === 'string' && p.includes('Specialmål højde'))
            );
            
            if (widthProp) {
              itemWidth = typeof widthProp === 'object' ? widthProp.value : widthProp;
            }
            if (heightProp) {
              itemHeight = typeof heightProp === 'object' ? heightProp.value : heightProp;
            }
          } else if (item.properties && typeof item.properties === 'object') {
            // Properties is an object
            itemWidth = item.properties['Specialmål bredde (cm)'] || 
                       item.properties['Special measure width (cm)'];
            itemHeight = item.properties['Specialmål højde (cm)'] || 
                        item.properties['Special measure height (cm)'];
          }
          
          if (itemWidth && itemHeight) {
            const itemWidthNum = parseFloat(itemWidth);
            const itemHeightNum = parseFloat(itemHeight);
            // Match if within 0.1 cm tolerance (for floating point comparison)
            if (!isNaN(itemWidthNum) && !isNaN(itemHeightNum)) {
              return Math.abs(itemWidthNum - customWidth) < 0.1 && 
                     Math.abs(itemHeightNum - customHeight) < 0.1;
            }
          }
          return false;
        }) || cartResponse.items[cartResponse.items.length - 1]; // Fallback to last item
        
        if (!addedItem) {
          return { needsFix: false };
        }

        // Extract variant dimensions from variant title (e.g., "NO121X100")
        const variantTitle = addedItem.variant_title || '';
        const variantMatch = variantTitle.match(/NO(\d+)X(\d+)/);
        if (!variantMatch) {
          return { needsFix: false };
        }

        const variantWidth = parseFloat(variantMatch[1]);
        const variantHeight = parseFloat(variantMatch[2]);

        // Check if variant is large enough for custom measurements
        const variantIsCorrect = variantWidth >= customWidth && variantHeight >= customHeight;

        if (variantIsCorrect) {
          return { needsFix: false };
        }

        // Variant is WRONG - need to fix it
        // Find the correct variant
        const correctVariant = this.findCorrectVariantForMeasurements(customWidth, customHeight);
        if (!correctVariant) {
          console.warn('Could not find correct variant for measurements:', customWidth, customHeight);
          return { needsFix: false };
        }

        // Remove wrong variant and add correct one
        const fixPromise = this.fixVariantInCart(addedItem.key, correctVariant, formData);

        return {
          needsFix: true,
          fixPromise: fixPromise
        };
      }

      findCorrectVariantForMeasurements(customWidth, customHeight) {
        // Get all available variants from the product
        const selectElements = document.querySelectorAll('.select__select');
        const variants = [];

        if (selectElements.length === 0) {
          console.warn('No select elements found for variant selection');
          return null;
        }

        selectElements.forEach((selectElement) => {
          selectElement.querySelectorAll('option').forEach((option) => {
            const value = option.value;
            if (!value) return;
            
            const match = value.match(/NO(\d+)X(\d+)/);
            if (match) {
              const widthDimension = parseFloat(match[1]);
              const heightDimension = parseFloat(match[2]);
              
              if (!isNaN(widthDimension) && !isNaN(heightDimension)) {
                variants.push({
                  width: widthDimension,
                  height: heightDimension,
                  value: value,
                  option: option
                });
              }
            }
          });
        });
        
        if (variants.length === 0) {
          console.warn('No valid variants found');
          return null;
        }

        // Sort variants by size (smallest first)
        variants.sort((a, b) => {
          if (a.width !== b.width) {
            return a.width - b.width;
          }
          return a.height - b.height;
        });

        // Find the smallest variant that can accommodate the custom measurements
        for (let i = 0; i < variants.length; i++) {
          const variant = variants[i];
          if (variant.width >= customWidth && variant.height >= customHeight) {
            return variant;
          }
        }

        // If no variant is large enough, use the largest available
        return variants[variants.length - 1] || null;
      }

      async fixVariantInCart(wrongItemKey, correctVariant, originalFormData) {
        // Step 1: Remove the wrong variant from cart
        const removeResponse = await fetch(`${routes.cart_change_url}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            id: wrongItemKey,
            quantity: 0
          })
        }).then(res => res.json());

        // Step 2: Get the correct variant ID by setting select value and waiting for update
        let correctVariantId = await this.getVariantIdFromValue(correctVariant.value);
        if (!correctVariantId) {
          console.error('Could not find variant ID for:', correctVariant.value);
          // Try one more time with a longer delay
          await new Promise(resolve => setTimeout(resolve, 500));
          const retryVariantId = await this.getVariantIdFromValue(correctVariant.value);
          if (!retryVariantId) {
            console.error('Failed to get variant ID after retry');
            return removeResponse;
          }
          // Use retry variant ID
          correctVariantId = retryVariantId;
        }

        // Step 3: Add the correct variant with the same properties
        const addFormData = new FormData();
        addFormData.append('id', correctVariantId);
        addFormData.append('quantity', '1');
        
        // Copy all properties from original form (including custom measurements)
        for (const [key, value] of originalFormData.entries()) {
          if (key.startsWith('properties[')) {
            addFormData.append(key, value);
          }
        }

        // Add sections for cart update
        if (this.cart) {
          addFormData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          addFormData.append('sections_url', window.location.pathname);
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = addFormData;

        const addResponse = await fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json());

        return addResponse;
      }

      async getVariantIdFromValue(variantValue) {
        // First, try to find variant ID directly from product data
        // This is more reliable than waiting for DOM updates
        const variantSelects = document.querySelector('variant-selects');
        if (variantSelects) {
          // Try to get variant ID from product JSON data
          const productDataScript = variantSelects.querySelector('[data-selected-variant]');
          if (productDataScript) {
            try {
              const productData = JSON.parse(productDataScript.textContent);
              // Get all variants from product
              const productInfo = document.querySelector('product-info');
              if (productInfo && productInfo.dataset.url) {
                // Try to get variant ID from product JSON data
                // The product data script contains variant information
                const variantSelects = document.querySelector('variant-selects');
                if (variantSelects) {
                  // Get all options and find the one matching our variant value
                  const options = variantSelects.querySelectorAll('option');
                  for (const option of options) {
                    if (option.value === variantValue) {
                      // Try to get variant ID from data attributes or option value
                      // Note: We'll need to trigger the variant change to get the ID
                      // This is handled in the fallback below
                    }
                  }
                }
              }
            } catch (e) {
              console.warn('Could not parse product data:', e);
            }
          }
        }

        // Fallback: Set the select value to trigger variant update
        const selectElements = document.querySelectorAll('.select__select');
        let selectChanged = false;
        
        for (const selectElement of selectElements) {
          if (selectElement.value !== variantValue) {
            selectElement.value = variantValue;
            const changeEvent = new Event('change', { bubbles: true, cancelable: true });
            selectElement.dispatchEvent(changeEvent);
            selectChanged = true;
          }
        }

        if (!selectChanged) {
          // Variant already selected, just return current variant ID
          const currentId = this.variantIdInput.value;
          if (currentId && !isNaN(currentId)) {
            return currentId;
          }
        }

        // Wait for variant ID to update through product-info
        // The variant ID is updated asynchronously when select changes
        return new Promise((resolve) => {
          let attempts = 0;
          const maxAttempts = 30; // 3 seconds max wait (increased)
          
          const checkVariantId = () => {
            attempts++;
            const currentVariantId = this.variantIdInput.value;
            
            // Check if variant ID has been updated (it should be a number, not empty)
            if (currentVariantId && currentVariantId !== '' && !isNaN(currentVariantId)) {
              // Double-check: verify the variant ID matches the expected variant value
              // by checking if the variant title matches
              resolve(currentVariantId);
              return;
            }
            
            if (attempts >= maxAttempts) {
              console.error('Timeout waiting for variant ID update for:', variantValue);
              // Last resort: try to find variant ID from option data attributes
              const selectElements = document.querySelectorAll('.select__select option');
              for (const option of selectElements) {
                if (option.value === variantValue && option.dataset.variantId) {
                  resolve(option.dataset.variantId);
                  return;
                }
              }
              resolve(null);
              return;
            }
            
            setTimeout(checkVariantId, 100);
          };
          
          checkVariantId();
        });
      }
    }
  );
}
